var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0V0C43.464 0 56 12.536 56 28V28C56 43.464 43.464 56 28 56V56C12.536 56 0 43.464 0 28V28Z",
    fill: "#F5222D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0438 13.6295L16.9438 18.4189C15.5639 19.1452 14.7 20.5762 14.7 22.1356V33.8642C14.7 35.4236 15.5639 36.8546 16.9438 37.5809L26.0438 42.3704C27.2683 43.0148 28.7316 43.0148 29.9561 42.3704L39.0561 37.5809C40.436 36.8546 41.3 35.4236 41.3 33.8642V22.1356C41.3 20.5762 40.436 19.1452 39.0561 18.4189L29.9561 13.6295C28.7316 12.985 27.2683 12.985 26.0438 13.6295ZM28 20.6499C28.5799 20.6499 29.05 21.12 29.05 21.6999V29.3999C29.05 29.9798 28.5799 30.4499 28 30.4499C27.4201 30.4499 26.95 29.9798 26.95 29.3999V21.6999C26.95 21.12 27.4201 20.6499 28 20.6499ZM29.4 33.8798C29.4 33.1066 28.7732 32.4798 28 32.4798C27.2268 32.4798 26.6 33.1066 26.6 33.8798V34.0198C26.6 34.793 27.2268 35.4198 28 35.4198C28.7732 35.4198 29.4 34.793 29.4 34.0198V33.8798Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/ErrorCircle.ece00006.svg";
export { ForwardRef as ReactComponent };